import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, Globe, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-white/10 mt-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="col-span-1 lg:col-span-2">
            <img 
              src="https://customer-assets.emergentagent.com/job_sleek-ai-agency-2/artifacts/a4mq980t_Logo.jpg"
              alt="Blue MP Logo" 
              className="w-auto object-contain mb-4"
              style={{ height: '90px' }}
            />
            <p className="body-medium text-gray-300 mb-6 max-w-md">
              Blending AI with Integrity. Delivering responsible, high-impact artificial intelligence solutions for forward-thinking organizations.
            </p>
            <div className="text-bluemp-400 heading-3 mb-2">
              Powered by AI, guided by integrity
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="heading-3 text-white mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li><Link to="/about" className="body-small text-gray-300 hover:text-bluemp-400 transition-colors">About</Link></li>
              <li><Link to="/solutions" className="body-small text-gray-300 hover:text-bluemp-400 transition-colors">Solutions</Link></li>
              <li><Link to="/ai-learning" className="body-small text-gray-300 hover:text-bluemp-400 transition-colors">AI Learning</Link></li>
              <li><Link to="/experience" className="body-small text-gray-300 hover:text-bluemp-400 transition-colors">Experience</Link></li>
              <li><Link to="/insights" className="body-small text-gray-300 hover:text-bluemp-400 transition-colors">Insights</Link></li>
              <li><Link to="/contact" className="body-small text-gray-300 hover:text-bluemp-400 transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Contact Information */}
          <div>
            <h3 className="heading-3 text-white mb-4">Contact Info</h3>
            <ul className="space-y-3">
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-bluemp-400" />
                <span className="body-small text-gray-300">+27 84 512 3122</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-bluemp-400" />
                <span className="body-small text-gray-300">info@bluemp.biz</span>
              </li>
              <li className="flex items-center gap-3">
                <Globe size={16} className="text-bluemp-400" />
                <span className="body-small text-gray-300">www.bluemp.biz</span>
              </li>
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-bluemp-400" />
                <span className="body-small text-gray-300">Cape Town, South Africa</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="body-small text-gray-400">
            © {currentYear} Blue MP. All rights reserved.
          </p>
          <div className="mt-4 md:mt-0">
            <Link 
              to="/contact" 
              className="btn-primary"
            >
              Book a Discovery Call
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;